export { default } from './HoverDescriptionItem';
